export const AUTH_VERIFY_RESPONSE_SSO = 'SSO_LOGIN'
export const AUTH_PLATFORM = {
  SA: 'SEARCHADS_COM',
  MA: 'MA_DASHBOARD',
}
